export const EffortEncRow = function () {
  this.gearcode = "";
  this.gearname = "";
  this.mesh_size = null;
  this.gearqty = null;
  this.gearsize = null;
  this.number_of_hauls = null;
  this.tow_soak_time = { hours: null, minutes: null };
  this.lat_long_format = null;
  this.latitude_or_loran1 = {
    decimal_degrees: "",
    degrees_decimal_minutes: { degrees: "", minutes: "" },
    degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
  };
  this.longitude_or_loran2 = {
    decimal_degrees: "",
    degrees_decimal_minutes: { degrees: "", minutes: "" },
    degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
  };
  this.chart_area = null;
  this.fishing_depth = null;
  this.fishing_depth_uom = "fa";
  this.serial_num = null;
  this.catch = [];
  this.numTrapsHauled = null;
  this.numTrapsInWater = null;
  this.numTrapsPerString = null;
  this.numBuoyLines = null;
  this.stringsHauled = null;
  this.avgSoakTime = null;
};
EffortEncRow.prototype.setCatch = function (catchArray) {
  this.catch = catchArray;
};

EffortEncRow.prototype.setSerialNum = function (serial_num) {
  this.serial_num = serial_num;
};
EffortEncRow.prototype.setGearCode = function (gear_code) {
  this.gearcode = gear_code;
};
EffortEncRow.prototype.setGearName = function (gear_name) {
  this.gearname = gear_name;
};
EffortEncRow.prototype.setMeshSize = function (mesh_size) {
  this.mesh_size = mesh_size;
};
EffortEncRow.prototype.setGearQty = function (gear_qty) {
  this.gearqty = gear_qty;
};
EffortEncRow.prototype.setGearSize = function (gear_size) {
  this.gearsize = gear_size;
};
EffortEncRow.prototype.setNumberOfHauls = function (number_of_hauls) {
  this.number_of_hauls = number_of_hauls;
};
EffortEncRow.prototype.setSoakTime = function (soakHours, soakMinutes) {
  this.tow_soak_time = { hours: soakHours, minutes: soakMinutes };
};
EffortEncRow.prototype.setLanLongFormat = function (format) {
  this.lat_long_format = format;
};
EffortEncRow.prototype.setLatitude = function (latitude) {
  this.latitude_or_loran1 = latitude;
};
EffortEncRow.prototype.setLongitude = function (longitude) {
  this.longitude_or_loran2 = longitude;
};
EffortEncRow.prototype.setChartArea = function (chart_area) {
  this.chart_area = chart_area;
};
EffortEncRow.prototype.setFishingDepth = function (fishing_depth) {
  this.fishing_depth = fishing_depth;
};
EffortEncRow.prototype.setFishingDepthUom = function (fishing_depth_uom) {
  this.fishing_depth_uom = fishing_depth_uom;
};
EffortEncRow.prototype.setNumTrapsHauled = function (numTrapsHauled) {
  this.numTrapsHauled = numTrapsHauled;
};
EffortEncRow.prototype.setNumTrapsInWater = function (numTrapsInWater) {
  this.numTrapsInWater = numTrapsInWater;
};
EffortEncRow.prototype.setNumTrapsPerString = function (numTrapsPerString) {
  this.numTrapsPerString = numTrapsPerString;
};
EffortEncRow.prototype.setNumBuoyLines = function (numBuoyLines) {
  this.numBuoyLines = numBuoyLines;
};
EffortEncRow.prototype.setStringsHauled = function (stringsHauled) {
  this.stringsHauled = stringsHauled;
};
EffortEncRow.prototype.setAvgSoakTime = function (avgSoakTime) {
  this.avgSoakTime = avgSoakTime;
};
export const validateGear = function (gearValidations, gearCode, newState) {
  console.log("validateGear", gearCode, newState);
  if (!gearCode) {
    console.info("no gear provided for validation");
    return newState;
  }
  for (let e = 0; e < gearValidations.length; e++) {
    if (gearCode === gearValidations[e].CODE) {
      newState.gearname = gearValidations[e].NAME;
      //Mesh size
      if (
        gearValidations[e].hasOwnProperty("MESH_MINIMUM") &&
        gearValidations[e].hasOwnProperty("MESH_MAXIMUM")
      ) {
        newState.mesh_size_minimum = gearValidations[e].MESH_MINIMUM;
        newState.mesh_size_maximum = gearValidations[e].MESH_MAXIMUM;
        if (
          (gearValidations[e].MESH_MINIMUM === "0" &&
            gearValidations[e].MESH_MAXIMUM === "0") ||
          (gearValidations[e].MESH_MINIMUM === "" &&
            gearValidations[e].MESH_MAXIMUM === "") ||
          (gearValidations[e].MESH_MINIMUM === null &&
            gearValidations[e].MESH_MAXIMUM === null)
        ) {
          newState.show_mesh_size = false;
        } else {
          newState.show_mesh_size = true;
        }
      }
      //Quantity
      if (
        gearValidations[e].hasOwnProperty("QUANTITY_MINIMUM") &&
        gearValidations[e].hasOwnProperty("QUANITY_MAXIMUM")
      ) {
        newState.gear_qty_minimum = gearValidations[e].QUANTITY_MINIMUM;
        newState.gear_qty_maximum = gearValidations[e].QUANITY_MAXIMUM;
        if (
          (gearValidations[e].QUANTITY_MINIMUM === "0" &&
            gearValidations[e].QUANITY_MAXIMUM === "0") ||
          (gearValidations[e].QUANTITY_MINIMUM === "" &&
            gearValidations[e].QUANITY_MAXIMUM === "") ||
          (gearValidations[e].QUANTITY_MINIMUM === null &&
            gearValidations[e].QUANITY_MAXIMUM === null)
        ) {
          newState.show_gear_qty = false;
        } else {
          newState.show_gear_qty = true;
        }
      }
      //GearSize
      if (
        gearValidations[e].hasOwnProperty("SIZE_MINIMUM") &&
        gearValidations[e].hasOwnProperty("SIZE_MAXIMUM")
      ) {
        newState.gear_size_minimum = gearValidations[e].SIZE_MINIMUM;
        newState.gear_size_maximum = gearValidations[e].SIZE_MAXIMUM;
        if (
          (gearValidations[e].SIZE_MINIMUM === "0" &&
            gearValidations[e].SIZE_MAXIMUM === "0") ||
          (gearValidations[e].SIZE_MINIMUM === "" &&
            gearValidations[e].SIZE_MAXIMUM === "") ||
          (gearValidations[e].SIZE_MINIMUM === null &&
            gearValidations[e].SIZE_MAXIMUM === null)
        ) {
          newState.show_gear_size = false;
        } else {
          newState.show_gear_size = true;
        }
      }
      //Hauls
      if (
        gearValidations[e].hasOwnProperty("HAULS_MINIMUM") &&
        gearValidations[e].hasOwnProperty("HAULS_MAXIMUM")
      ) {
        newState.number_hauls_minimum = gearValidations[e].HAULS_MINIMUM;
        newState.number_hauls_maximum = gearValidations[e].HAULS_MAXIMUM;
        if (
          (gearValidations[e].HAULS_MINIMUM === "0" &&
            gearValidations[e].HAULS_MAXIMUM === "0") ||
          (gearValidations[e].HAULS_MINIMUM === "" &&
            gearValidations[e].HAULS_MAXIMUM === "") ||
          (gearValidations[e].HAULS_MINIMUM === null &&
            gearValidations[e].HAULS_MAXIMUM === null)
        ) {
          newState.show_number_of_hauls = false;
        } else {
          newState.show_number_of_hauls = true;
        }
      }

      //Soak time
      if (
        gearValidations[e].hasOwnProperty("SOAK_MINIMUM") &&
        gearValidations[e].hasOwnProperty("HAULS_MAXIMUM")
      ) {
        newState.soak_hours_minimum = gearValidations[e].SOAK_MINIMUM;
        newState.soak_hours_maximum = gearValidations[e].SOAK_MAXIMUM;
        if (
          (gearValidations[e].SOAK_MINIMUM === "0" &&
            gearValidations[e].SOAK_MAXIMUM === "0") ||
          (gearValidations[e].SOAK_MINIMUM === "" &&
            gearValidations[e].SOAK_MAXIMUM === "") ||
          (gearValidations[e].SOAK_MINIMUM === null &&
            gearValidations[e].SOAK_MAXIMUM === null)
        ) {
          newState.show_soak_time = false;
        } else {
          newState.show_soak_time = true;
        }
      }

      //finally stop the loop
      break;
    }
  }
  return newState;
};

export const getInitialGearState = function () {
  this.gearcode = "";
  this.gearname = "";
  this.show_mesh_size = false;
  this.mesh_size_minimum = null;
  this.mesh_size_maximum = null;
  this.show_gear_qty = false;
  this.gear_qty_minimum = null;
  this.gear_qty_maximum = null;
  this.show_gear_size = false;
  this.gear_size_minimum = null;
  this.gear_size_maximum = null;
  this.show_number_of_hauls = false;
  this.number_of_hauls_minimum = null;
  this.number_of_hauls_maximum = null;
  this.show_soak_time = false;
  this.soak_hours_minimum = null;
  this.soak_hours_maximum = null;
};

export const handleGearCodeChange = function (event, reason) {
  console.log("gear_code_change_event", event);
  console.log("gear_code_change_reason", reason);
  let newState = new getInitialGearState();
  if (reason) {
    //Save the new values when selected
    if (reason.hasOwnProperty("CODE") && reason.hasOwnProperty("NAME")) {
      console.log("gearchange_props", this.props);

      let gearValidations = this.props.validations.validations.gear;
      if (!Array.isArray(gearValidations)) {
        console.error("Not an array:", gearValidations);
        return false;
      }
      newState.gearcode = reason.CODE;
      newState.gearname = reason.NAME;
      newState = validateGear(gearValidations, reason.CODE, newState);
    }
  }
  console.log("beforeupdateState", newState);
  this.setState(newState);
};

export const handleGearPreferenceChange = function (event) {
  event.preventDefault();
  let newValue = event.currentTarget.dataset.newValue;
  let field = event.currentTarget.dataset.field;
  if (!newValue) {
    console.log("No new value provided");
    return;
  }
  if (!field) {
    console.error("No field provided");
    return;
  }

  let newState = {};
  newState[field] = newValue;
  console.info("prefchange", newState);

  this.setState(newState);
};

export const handleGearCodePreferenceChange = function (event) {
  event.preventDefault();
  let gearCode = event.currentTarget.dataset.gearCode;
  if (!gearCode) {
    console.log("No gear_code provided");
    return;
  }

  let newState = new getInitialGearState();
  let gearValidations = this.props.validations.validations.gear;
  if (!Array.isArray(gearValidations)) {
    console.error("Not an array:", gearValidations);
    return false;
  }
  newState.gearcode = gearCode;
  newState = validateGear(gearValidations, gearCode, newState);
  console.log("gearPref", newState);

  this.setState(newState);
};

export const handleChartAreaChange = function (event, reason) {
  console.log("gear_code_change_event", event);
  console.log("gear_code_change_reason", reason);
  if (reason) {
    //Save the new values when selected
    if (reason.hasOwnProperty("AREA_CODE")) {
      this.setState({
        chart_area: reason.AREA_CODE,
      });
    }
  } else {
    //If emptied then empty the state
    this.setState({
      chart_area: "",
    });
  }
};

export const handleTowSoakTimeChange = function (event) {
  console.log("handleTowSoakTimeChange", event);

  const { name, value } = event.target;
  if (name === "tow_soak_time_hours") {
    this.setState({
      tow_soak_time: {
        hours: value,
        minutes: this.state.tow_soak_time.minutes,
      },
    });
  }
  if (name === "tow_soak_time_minutes") {
    this.setState({
      tow_soak_time: {
        hours: this.state.tow_soak_time.hours,
        minutes: value,
      },
    });
  }
};

export const currentLocationHandler = function (currentState, updateState) {
  return function (event) {
    event.preventDefault();

    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function success(pos) {
      let coord = pos.coords;
      let newLatitude = { ...currentState.latitude_or_loran1 }; // Create a copy to avoid direct state mutation
      newLatitude.decimal_degrees = coord.latitude.toFixed(4);

      let newLongitude = { ...currentState.longitude_or_loran2 }; // Create a copy to avoid direct state mutation
      newLongitude.decimal_degrees = coord.longitude.toFixed(4);

      updateState({
        // Use the updateState function provided by the functional component
        ...currentState,
        lat_long_format: "Decimal Degrees",
        latitude_or_loran1: newLatitude,
        longitude_or_loran2: newLongitude,
      });
    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  };
};

export const handleLatLongFormatChange = function (event) {
  event.preventDefault();
  const latLonFormatValue =
    "dataset" in event.target ? event.target.dataset.latLonFormat : event.target.value;
  this.setState({
    lat_long_format: latLonFormatValue,
  });
};

export const handleLatChange = function (event) {
  event.preventDefault();
  console.log("lat_change_event", event);
  const { name, value } = event.target;
  let longLatFormat = this.state.lat_long_format;
  let Latitude = this.state.latitude_or_loran1;
  if (longLatFormat === "Decimal Degrees") {
    Latitude.decimal_degrees = value;
  }
  if (longLatFormat === "Degrees Decimal Minutes") {
    Latitude.degrees_decimal_minutes[name] = value;
  }

  if (longLatFormat === "Degrees Minutes Seconds") {
    Latitude.degrees_minutes_seconds[name] = value;
  }

  this.setState({
    latitude_or_loran1: Latitude,
  });
};

export const handleLonChange = function (event) {
  console.log("lon_change_event", event);
  const { name, value } = event.target;
  let longLatFormat = this.state.lat_long_format;
  let Longitude = this.state.longitude_or_loran2;
  if (longLatFormat === "Decimal Degrees") {
    Longitude.decimal_degrees = value;
  }
  if (longLatFormat === "Degrees Decimal Minutes") {
    Longitude.degrees_decimal_minutes[name] = value;
  }

  if (longLatFormat === "Degrees Minutes Seconds") {
    Longitude.degrees_minutes_seconds[name] = value;
  }

  this.setState({
    longitude_or_loran2: Longitude,
  });
};

function getEffort(tripObject) {
  if (!tripObject || !tripObject.hasOwnProperty("effortNr")) {
    console.error("No tripobject or no effortNr presented", tripObject);
    return false;
  }
  let effortNr = tripObject.effortNr;
  if (
    !tripObject.hasOwnProperty("trip") ||
    !tripObject.trip ||
    !tripObject.trip.hasOwnProperty("images") ||
    !Array.isArray(tripObject.trip.images) ||
    !tripObject.trip.images[effortNr]
  ) {
    console.error("No trip or effort in tripObject tripObject", tripObject);
    return false;
  }
  return tripObject.trip.images[effortNr];
}

export const getEffortGearCode = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("gearcode")) {
    console.error("No gearcode in effort", effort);
    return "";
  }
  return effort.gearcode;
};
export const getEffortGearQty = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("gearqty")) {
    console.error("No gearqty in effort", effort);
    return "";
  }
  return effort.gearqty;
};
export const getEffortGearSize = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("gearsize")) {
    console.error("No gearqty in effort", effort);
    return "";
  }
  return effort.gearsize;
};
export const getEffortMeshSize = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("mesh_size")) {
    console.error("No mesh_size in effort", effort);
    return "";
  }
  return effort.mesh_size;
};
export const getEffortChartArea = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("chart_area")) {
    console.error("No chart_area in effort", effort);
    return "";
  }
  return effort.chart_area;
};
export const getEffortNumberOfHauls = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("number_of_hauls")) {
    console.error("No number_of_hauls in effort", effort);
    return "";
  }
  return effort.number_of_hauls;
};
export const getEffortTowSoakTime = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("tow_soak_time")) {
    console.error("No tow_soak_time in effort", effort);
    return "";
  }
  return effort.tow_soak_time;
};
export const getEffortFishingDepth = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("fishing_depth")) {
    console.error("No fishing_depth in effort", effort);
    return "";
  }
  return effort.fishing_depth;
};
export const getEffortFishingDepthUom = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("fishing_depth_uom")) {
    console.error("No fishing_depth_uom in effort", effort);
    return "";
  }
  return effort.fishing_depth_uom;
};
export const getEffortLatitude = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("latitude_or_loran1")) {
    console.error("No latitude_or_loran1 in effort", effort);
    return "";
  }
  return effort.latitude_or_loran1;
};
export const getEffortLongitude = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("longitude_or_loran2")) {
    console.error("No longitude_or_loran2 in effort", effort);
    return "";
  }
  return effort.longitude_or_loran2;
};
export const getEffortLatLonFormat = function (tripObject) {
  let effort = getEffort(tripObject);
  if (!effort || !effort.hasOwnProperty("lat_long_format")) {
    console.error("No lat_long_format in effort", effort);
    return "";
  }
  return effort.lat_long_format;
};

export const displayLatitudeLongitude = function (format, lat_long) {
  if (!format) {
    console.error("No latitude format");
    return null;
  }
  if (format === "Decimal Degrees") {
    return lat_long.decimal_degrees;
  }
  const CHAR_DEG = "\u00B0";
  const CHAR_MIN = "\u0027";
  const CHAR_SEC = "\u0022";
  if (format === "Degrees Decimal Minutes") {
    return (
      lat_long.degrees_decimal_minutes.degrees +
      CHAR_DEG +
      " " +
      lat_long.degrees_decimal_minutes.minutes +
      CHAR_MIN
    );
  }
  if (format === "Degrees Minutes Seconds") {
    return (
      lat_long.degrees_minutes_seconds.degrees +
      CHAR_DEG +
      " " +
      lat_long.degrees_minutes_seconds.minutes +
      CHAR_MIN +
      " " +
      lat_long.degrees_minutes_seconds.seconds +
      CHAR_SEC
    );
  }
  return "unexpected format " + format;
};

export const DECIMAL_DEGREES = "Decimal Degrees";
export const DEGREES_DECIMAL_MINUTES = "Degrees Decimal Minutes";
export const DEGREES_MINUTES_SECONDS = "Degrees Minutes Seconds";

export const pad = function (num, size) {
  let s = String(num);
  if (size === null) {
    size = 2;
  }
  if (s.length < size) {
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
  }
  return s;
};

export const getNrEfforts = function (currentTrip) {
  console.group("getNrEfforts");
  console.log(currentTrip);
  let nrEfforts = 0;
  if (
    currentTrip &&
    currentTrip.images &&
    currentTrip.images.length > 0 &&
    currentTrip.images[0].hasOwnProperty("gearcode")
  ) {
    console.log("found efforts");
    nrEfforts = currentTrip.images.length;
  }
  console.log(nrEfforts);
  console.groupEnd();
  return nrEfforts;
};
